import React, { Component } from 'react'
import { connect } from 'react-redux'
import FolderSelectorContents from './folder-selector-contents'
import SmoothCollapse from 'react-smooth-collapse'

import { find } from 'lodash'
import { doClickEventListeners} from 'utils'

class FolderSelector extends Component {
	constructor(props){
		super(props)

		const {
			allFolders,
			folderChain,
			isFileFolder,
			currentProject
		} = this.props

		this.rootFolder = isFileFolder ? currentProject : allFolders[folderChain[0]]

		this.state = {
			isOpened: false,
		}

		this.ref = null
	}

	UNSAFE_componentWillMount(){
		doClickEventListeners(this.handleClick)
	}

	componentWillUnmount(){
		doClickEventListeners(this.handleClick, true)
	}

	handleClick = e => {
		const {
			isOpened,
			forceCloseMenu
		} = this.props

		if(!this.ref.contains(e.target) && isOpened){
			forceCloseMenu()
		}
	}

	parentFolderChange = folderId => {
		const {
			parentFolderChange
		} = this.props

		parentFolderChange(folderId)
	}

	render(){
		const {
			currentParentId,
			allFolders,
			allFileFolders,
			isFileFolder,
			isOpened,
			toggleMenu,
			isFolder,
			folderId
		} = this.props

		let name = '(None)'
		let normalisedFolders = {}

		if(isFileFolder){
			normalisedFolders = allFileFolders
		}else{
			normalisedFolders = allFolders
		}

		if(currentParentId){
			const folderObject = normalisedFolders[currentParentId]

			if(folderObject && !folderObject.is_root){
				name = normalisedFolders[currentParentId].name
			}
		}

		return (
			<div className="folder-selector-dropdown">
				<label>
					Parent folder:
				</label>
				<div ref={ref => this.ref = ref}>
					<span className={isOpened ? 'open' : null} onClick={toggleMenu}>
						{ name }
					</span>
					<div onClick={e => {e.stopPropagation()}}>
						<SmoothCollapse heightTransition="0.1s ease" expanded={isOpened}>
							<ul>
								<FolderSelectorContents 
									isFolder={isFolder} 
									folderId={folderId} 
									parentFolderChange={this.parentFolderChange} 
									currentParentId={currentParentId} 
									depth={0} 
									allFolders={normalisedFolders} 
									folder={this.rootFolder} 
									isFileFolder={isFileFolder}
								/>
							</ul>
						</SmoothCollapse>
					</div>
				</div>
			</div>
		);
	}

}

const mapStateToProps = state => {
  return {
	allFolders: state.account.entities.folders,
	allFileFolders: state.account.entities.file_folders,
	folderChain: state.account.folderChain,
  };
}

export default connect(mapStateToProps, null)(FolderSelector);
